export enum FollowUpStudyCompletionParty {
	Complainant = "COMPLAINANT",
	Respondent = "RESPONDENT",
}
